var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo } from 'react';
import getValueLength from '../../utils/getValueLength';
import validate from '../FormItem/validate';
import { isFunction } from '../../utils';
export default function useTextField(props) {
    var _this = this;
    var max = props.max, inputProps = props.inputProps, InputProps = props.InputProps, errorProp = props.error, valueProp = props.value, onChangeProp = props.onChange, onBlurProp = props.onBlur, validateFn = props.validate, requiredProp = props.required, rulesProp = props.rules;
    var _a = React.useState(errorProp), error = _a[0], setError = _a[1];
    var rules = useMemo(function () {
        var _rules = [];
        if ((rulesProp === null || rulesProp === void 0 ? void 0 : rulesProp.length) > 0) {
            _rules = rulesProp === null || rulesProp === void 0 ? void 0 : rulesProp.map(function (rule) {
                if (rule.required) {
                    return __assign({ type: 'required' }, rule);
                }
                return rule;
            });
        }
        // 添加必填规则
        if (requiredProp) {
            _rules.push({
                type: 'required'
            });
        }
        // 添加最大长度限制
        if (max) {
            _rules.push({
                type: 'max'
            });
        }
        return _rules;
    }, [requiredProp, rulesProp, max]);
    var validateRules = React.useCallback(function (value) {
        if (value === void 0) { value = valueProp; }
        return __awaiter(_this, void 0, void 0, function () {
            var ruleError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validate({
                            value: value,
                            max: max,
                            rules: rules,
                            label: props.label,
                        })];
                    case 1:
                        ruleError = _a.sent();
                        setError(ruleError);
                        return [2 /*return*/, ruleError];
                }
            });
        });
    }, [valueProp]);
    var handleChange = function (event) {
        var _a, _b;
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(event);
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange) === null || _a === void 0 ? void 0 : _a.call(inputProps, event);
        var value = (event === null || event === void 0 ? void 0 : event.target) ? (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value : event;
        validateRules(value);
    };
    var handleBlur = function (event) {
        var _a, _b;
        onBlurProp === null || onBlurProp === void 0 ? void 0 : onBlurProp(event);
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(inputProps, event);
        var value = (event === null || event === void 0 ? void 0 : event.target) ? (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value : event;
        validateRules(value);
    };
    var handleValidate = React.useCallback(function (value) {
        if (value === void 0) { value = valueProp; }
        return __awaiter(_this, void 0, void 0, function () {
            var ruleError, errMsg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // onChang 验证没通过
                        if (error !== undefined)
                            return [2 /*return*/, error
                                // 没触发onchange，则重新调一遍ruls验证
                            ];
                        if (!(error === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, validateRules()];
                    case 1:
                        ruleError = _a.sent();
                        if (ruleError) {
                            return [2 /*return*/, ruleError];
                        }
                        _a.label = 2;
                    case 2:
                        if (!(validateFn && isFunction(validateFn))) return [3 /*break*/, 4];
                        return [4 /*yield*/, validateFn(value, props)];
                    case 3:
                        errMsg = _a.sent();
                        setError(errMsg);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [error, valueProp]);
    var length = getValueLength({ value: valueProp, max: max }).length;
    return Object.assign(props, {
        error: errorProp || error,
        length: length,
        setError: setError,
        handleValidate: handleValidate,
        InputProps: __assign(__assign(__assign({}, inputProps), InputProps), { value: valueProp, onChange: handleChange, onBlur: handleBlur })
    });
}
